import { LoyaltyMembership } from '@mews-commander/data-access';
import { EllipsizedSpan } from '@mews-commander/ui';
import { Icon, Stack, Typography } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { LoyaltyMembershipLabel } from '../../../../../components/commander-ui/connected/LoyaltyMembershipLabel';

interface LoyaltyMembershipInfoProps {
    loyaltyMembership: LoyaltyMembership;
}

export const LoyaltyMembershipInfo = ({ loyaltyMembership }: LoyaltyMembershipInfoProps) => (
    <Typography textStyle="bodySmall" variant="secondary" as="div">
        <Stack spacing="50" alignment="center">
            <Icon value={IconName.Loyalty} size="small" />
            <EllipsizedSpan>
                <LoyaltyMembershipLabel loyaltyMembership={loyaltyMembership} />
            </EllipsizedSpan>
        </Stack>
    </Typography>
);
